import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { strings } from "@/i18n/strings";
import { useSite } from "@/context/SiteContext";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [chosen, setLang] = useState(() => localStorage.getItem("aik-lang") || "en");
  const { settings, veMode } = useSite();
  const switchOn = settings?.lang_switch_enabled === true;
  const lang = switchOn || veMode === "edit" ? chosen : "en";
  useEffect(() => {
    localStorage.setItem("aik-lang", chosen);
  }, [chosen]);
  useEffect(() => {
    document.documentElement.lang = lang === "mh" ? "mh" : "en";
  }, [lang]);
  const over = useMemo(() => settings?.text || {}, [settings?.text]);
  const hidden = useMemo(() => settings?.hidden || {}, [settings?.hidden]);
  const t = useCallback((k) => (hidden[`t:${k}`] ? "" : over[lang]?.[k] || strings[lang]?.[k] || over.en?.[k] || strings.en[k] || k), [lang, over, hidden]);
  const pick = useCallback((en, mh) => (lang === "mh" && mh && !mh.startsWith("[") ? mh : en), [lang]);
  return <LangContext.Provider value={{ lang, setLang, t, pick, switchOn }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
